import { useQuery } from '@tanstack/react-query';
import apiFetch from '@wordpress/api-fetch';

/**
 * Fetch recipes with pagination and search
 * @returns {object}
 */
function useLocalEventsTaxonomies() {
	const { isPending, isError, data, error } = useQuery({
		queryKey: ['taxonomies'],
		queryFn: async () => {
			/* Add the nonce as middleware. This automatically adds the `X-WP-Nonce` header to requests. */
			apiFetch.use(
				apiFetch.createNonceMiddleware(window.visitEduSettings.nonce)
			);

			const response = await apiFetch({
				path: '/visitedu-block-theme/v1/events/taxonomies',
				parse: false,
			});

			return await response.json();
		},
	});

	return {
		data,
		error,
		isError,
		isPending,
	};
}

export { useLocalEventsTaxonomies };
